import People from './People';
import RoleMembers from './RoleMembers';

class Work {
  sfawardWorkId = 0;

  name = '';

  sfawardEntryId = 0;

  selectedSetId = 0;

  sfawardEntrySelectedSetId = 0;

  team = [];

  constructor(work) {
    if (work != null) {
      this.sfawardWorkId = work.sfawardWorkId;
      this.name = work.name;
      this.sfawardEntryId = work.sfawardEntryId;
      this.selectedSetId = work.selectedSetId;
      this.sfawardEntrySelectedSetId = work.sfawardEntrySelectedSetId;
      // this.team = People.fromObjectList(work.kcmPeople);
      this.team = RoleMembers.fromObjectList(work.team);
    }
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }
    return new Work(data);
  }

  static fromObjectList(list) {
    if (list == null) {
      return null;
    }

    return list.map((data) => Work.fromObject(data));
  }
}

export default Work;
